import { useLayoutEffect } from 'react';

import { useNavigate, useParams } from 'react-router';

import { useGetAdmissionSurveyQuery } from '@/api/endpoints/schools/schoolSelectionPanel';
import type { IApiError } from '@/api/types';
import { FetchDataWrapper } from '@/shared/components';
import { ROUTES } from '@/shared/consts';

import { SurveyEditPage } from './SurveyEditPage';

export const SurveyEditPageWrapper = () => {
  const { id: schoolId } = useParams();

  const {
    data: surveyData,
    isLoading: isSurveyLoading,
    isError: isSurveyFetchError,
    error,
  } = useGetAdmissionSurveyQuery({ schoolId: Number(schoolId) });

  const navigate = useNavigate();

  useLayoutEffect(() => {
    if ((error as IApiError)?.status === 404) {
      navigate(
        `/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.ADMISSION_SURVEY}/${ROUTES.CREATE}`,
      );
    }
  }, [error]);

  return (
    <FetchDataWrapper
      isLoading={isSurveyLoading}
      isError={isSurveyFetchError}
    >
      {surveyData && <SurveyEditPage surveyData={surveyData} />}
    </FetchDataWrapper>
  );
};
